import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-deep-black relative overflow-hidden">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%230F2A1D' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/884dfa3b03bef19a046381f60df37b46.jpeg" 
                alt="High Standards Logo" 
                className="h-10 w-10 object-contain rounded-lg"
              />
              <span className="font-serif text-xl text-copper">High Standards</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Elevating your smoke experience with premium products and exceptional service in Eustis, Florida.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com/people/High-Standards-Smokes/61572635278359/?mibextid=wwXIfr&rdid=fZ6MP002yc7XVvTI&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1ArFGaDNXB%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-copper/30 rounded-full text-copper hover:bg-copper hover:text-deep-black transition-all duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/highstandardsmoke?igsh=MXd0YTRobGI0MWUzZw%3D%3D" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-copper/30 rounded-full text-copper hover:bg-copper hover:text-deep-black transition-all duration-200 cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://www.tiktok.com/@highstandards.smokes?_r=1&_t=ZS-94CMqcEiFwC" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-copper/30 rounded-full text-copper hover:bg-copper hover:text-deep-black transition-all duration-200 cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div>
            <h4 className="text-copper font-semibold text-sm uppercase tracking-wider mb-4">Shop</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/products" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Vapes & Disposables
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Premium Glass
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Hookah & Shisha
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Hemp Products
                </Link>
              </li>
            </ul>
          </div>

          {/* About Column */}
          <div>
            <h4 className="text-copper font-semibold text-sm uppercase tracking-wider mb-4">About</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Our Mission
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Visit Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-copper font-semibold text-sm uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <i className="ri-map-pin-line text-copper mt-0.5"></i>
                <span>1321 S Bay St<br />Eustis, FL 32726</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-copper"></i>
                <a href="tel:+13529774832" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  +1 352 977-4832
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-copper"></i>
                <a href="mailto:Highstandards.smokes@gmail.com" className="text-gray-400 hover:text-copper transition-colors duration-200 text-sm cursor-pointer">
                  Highstandards.smokes@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <i className="ri-time-line text-copper mt-0.5"></i>
                <span>Mon-Thu: 8am-10pm<br />Fri-Sat: 8am-11pm<br />Sun: 9am-9pm</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-copper/20 mb-8"></div>

        {/* Disclaimer Notice */}
        <div className="flex items-center justify-center gap-3 mb-6 px-4 py-3 border border-copper/20 rounded-lg bg-copper/5">
          <i className="ri-information-line text-copper text-lg flex-shrink-0"></i>
          <p className="text-gray-400 text-xs text-center leading-relaxed">
            No products are sold online. In-store purchase only. Valid government ID required.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © 2025 High Standards Smoke Shop. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="px-4 py-1.5 border border-copper/40 rounded-full text-copper text-xs font-medium">
              21+ ONLY
            </span>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-500 hover:text-copper transition-colors duration-200 text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
